import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7ec39e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "titleCollapsableMenu",
  class: "title"
}
const _hoisted_2 = {
  key: 0,
  class: "menu_items tw-max-w-[220px]"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "level-1_wrapper"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "level-2_wrapper"
}
const _hoisted_7 = {
  key: 1,
  class: "menu_items tw-max-w-[220px]"
}
const _hoisted_8 = {
  key: 0,
  class: "tw-bg-[#E4F1FF] tw-w-[190px] tw-py-[14px] tw-flex tw-items-center tw-justify-center tw-mx-[15px] tw-mb-[20px] tw-rounded-[4px]"
}
const _hoisted_9 = { class: "tw-mb-[20px] tw-whitespace-pre-line tw-text-[#211F58] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[135%] tw-pt-[1px] tw-px-[15px] tw-w-[220px]" }
const _hoisted_10 = {
  key: 1,
  class: "tw-mb-[0] tw-whitespace-pre-line tw-text-[#878787] tw-text-[11px] tw-not-italic tw-font-normal tw-leading-[135%] tw-pb-[16px] tw-px-[15px] tw-w-[220px]"
}
const _hoisted_11 = { class: "tw-font-semibold" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_collapsable_menu_item = _resolveComponent("collapsable-menu-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`collapsable-menu ${_ctx.chevronActive ? '' : 'borderNone'}`),
    style: {"background":"var(--UI-white, #fff)","box-shadow":"5px 0px 15px 0px rgba(167, 167, 167, 0.1)","position":"relative","z-index":"1"}
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`menu ${_ctx.isMenuOpen ? 'expand' : ''}`)
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.sectionTitle), 1),
      (!_ctx.menuItems[0].description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(`${
            _ctx.selectedMenuKeys[`level0`].id === item.id ? 'active' : ''
          } menu_item_wrapper tw-cursor-pointer `)
              }, [
                _createElementVNode("a", {
                  href: 
              _ctx.isCheckSubscription(item?.title) ? _ctx.urlSubscription : item.url
            ,
                  class: _normalizeClass(["!tw-no-underline", item?.title])
                }, [
                  _createVNode(_component_collapsable_menu_item, {
                    "menu-item": item,
                    index: index,
                    level: 0,
                    "is-selected": _ctx.selectedMenuKeys[`level0`].id === item.id,
                    danger: item.danger,
                    onSelectItem: _ctx.selectItem,
                    onLeafItemSelected: () => _ctx.handleLeafItemSelect(item),
                    onClick: _withModifiers(($event: any) => (_ctx.onClickMenuItem(item)), ["prevent"])
                  }, null, 8, ["menu-item", "index", "is-selected", "danger", "onSelectItem", "onLeafItemSelected", "onClick"])
                ], 10, _hoisted_3),
                (item.children && item.children?.length > 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subitem, subIndex) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: subitem.id,
                          href: subitem.url,
                          class: "level-1_items !tw-no-underline"
                        }, [
                          _createVNode(_component_collapsable_menu_item, {
                            "menu-item": subitem,
                            index: subIndex,
                            level: 1,
                            "is-selected": _ctx.selectedMenuKeys[`level1`].id === subitem.id,
                            onSelectItem: _ctx.selectItem,
                            onLeafItemSelected: () => _ctx.handleLeafItemSelect(subitem)
                          }, null, 8, ["menu-item", "index", "is-selected", "onSelectItem", "onLeafItemSelected"]),
                          (subitem.children && subitem.children?.length > 0)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subitem.children, (leafItem, leafIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: leafItem.id,
                                    style: {"overflow":"hidden"},
                                    class: "level-2_items"
                                  }, [
                                    _createVNode(_component_collapsable_menu_item, {
                                      "menu-item": leafItem,
                                      index: leafIndex,
                                      level: 2,
                                      "is-selected": _ctx.selectedMenuKeys[`level2`].id === leafItem.id,
                                      onSelectItem: _ctx.selectItem,
                                      onLeafItemSelected: () => _ctx.handleLeafItemSelect(leafItem),
                                      onClick: ($event: any) => (_ctx.onClickMenuItem(item))
                                    }, null, 8, ["menu-item", "index", "is-selected", "onSelectItem", "onLeafItemSelected", "onClick"])
                                  ]))
                                }), 128))
                              ], 512)), [
                                [_vShow, _ctx.selectedMenuKeys[`level1`].id === subitem.id]
                              ])
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_5))
                      }), 128))
                    ], 512)), [
                      [_vShow, _ctx.selectedMenuKeys[`level0`].id === item.id]
                    ])
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.menuItems[0].logo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.menuItems[0].logo)))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.menuItems[0].description), 1),
            (_ctx.menuItems[0].instruction)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.menuItems[0].instructionTitle), 1),
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(_ctx.menuItems[0].instruction), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 2)
  ], 2))
}